<template>
  <v-dialog
    v-model="computedGroomingWinchVisibility"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card>
        <!-- close icon -->
        <v-btn
          icon
          @click="methodToggleSingleLayer('grooming', 'winch', false)"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <span class="hidden-sm-and-down">{{ computedA_Number }}</span>
        </v-toolbar-title>
        <v-spacer />
        <!-- delete icon -->
        <v-tooltip bottom>
          <v-btn
            icon
            slot="activator"
            :disabled="disable_edit"
            @click="confirm_delete = true"
          >
            <v-icon>delete</v-icon>
          </v-btn>
          <span>Delete</span>
        </v-tooltip>
        <!-- zoom to icon -->
        <v-tooltip bottom>
          <v-btn
            icon
            slot="activator"
            @click="
              zoomTo({
                center: computedLatLng[0].geometry.coordinates,
                level: 18
              });
              methodCloseListLayer('grooming', 'winch');
              methodToggleSingleLayer('grooming', 'winch');
              if (
                !$store.state.mapLayers.grooming.layers.winch.visibility.mapView
              ) {
                methodToggleMapLayer('grooming', 'winch');
              }
            "
          >
            <v-icon>map</v-icon>
          </v-btn>
          <span>View on map</span>
        </v-tooltip>
        <!-- edit icon -->
        <v-tooltip bottom>
          <v-btn
            v-if="disable_edit"
            icon
            slot="activator"
            :disabled="computedAuthProfile != 'maintenance'"
            @click="disable_edit = !disable_edit"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn
            v-else
            icon
            slot="activator"
            color="info"
            :disabled="computedAuthProfile != 'maintenance'"
            @click="disable_edit = !disable_edit"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <span>Edit</span>
        </v-tooltip>
      </v-toolbar>
      <div
        style="background-color: black; padding-left: 30px; overflow:auto; -webkit-overflow-scrolling:touch;"
      >
        <v-data-table
          :items="computedGroomingWinchGeoJsonFeature"
          :loading="computedGroomingWinchLoading"
          :hide-actions="hideactions"
          :hide-headers="hideheaders"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td colspan="2">
                <span
                  v-if="
                    computedImageUrl !=
                      'https://api2.alchemymapping.com/images/null'
                  "
                >
                  <img
                    style="max-height: 90vh; max-width: 90vw;"
                    :src="computedImageUrl"
                  />
                </span>
              </td>
            </tr>
            <tr v-if="!disable_edit">
              <td>Update Image</td>
              <td>
                <image-uploader
                  @input="methodSetOutput"
                  :quality="0.7"
                  :autoRotate="attemptAutoRotate"
                  outputFormat="base64"
                  class="fileinput2"
                  :preview="true"
                  accept=".jpg"
                  :key="attemptAutoRotate"
                />
              </td>
            </tr>
            <tr v-if="!disable_edit">
              <td>EXIF rotate?</td>
              <td><v-checkbox v-model="attemptAutoRotate" class="mt-2" /></td>
            </tr>
            <tr>
              <td>Mountain</td>
              <td>
                <v-select
                  ref="ref_mountain"
                  :items="opt_mountain"
                  v-model="props.item.properties.mountain"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Zone</td>
              <td>
                <v-select
                  ref="ref_zone"
                  :items="computedZone"
                  v-model="props.item.properties.zone"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Run Name</td>
              <td>
                <v-autocomplete
                  ref="ref_trail_name"
                  :items="computedTrailName"
                  v-model="props.item.properties.trail_name"
                  :disabled="disable_edit"
                />
              </td>
            </tr>
            <tr>
              <td>Anchor Number</td>
              <td>
                <v-text-field
                  name="a_number"
                  ref="ref_a_number"
                  v-model="props.item.properties.a_number"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Location Description</td>
              <td>
                <v-text-field
                  name="loc_descript"
                  ref="ref_loc_descript"
                  v-model="props.item.properties.loc_descript"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Cable Length Required</td>
              <td>
                {{ props.item.properties.rope_length }}
              </td>
            </tr>
            <tr>
              <td>Start Time</td>
              <td>
                {{ props.item.properties.st_time }}
              </td>
            </tr>
            <tr>
              <td>Finish Time</td>
              <td>
                {{ props.item.properties.fin_time }}
              </td>
            </tr>
            <tr>
              <td>Sign & Light Locations</td>
              <td>
                {{ props.item.properties.s_li_loc }}
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <template>
                  <v-expansion-panel flat>
                    <v-expansion-panel-content>
                      <template v-slot:header>
                        <div style="max-width: 100;">
                          <v-btn color="primary" small>Annual Inspection</v-btn>
                        </div>
                      </template>
                      <v-card>
                        <v-data-table
                          :items="computedGroomingWinchGeoJsonFeature"
                          :loading="computedGroomingWinchLoading"
                          :hide-actions="hideactions"
                          :hide-headers="hideheaders"
                          class="elevation-0"
                        >
                          <template v-slot:items="props">
                            <tr>
                              <td>
                                Inspection Date:
                              </td>
                              <td colspan="2">
                                <v-menu
                                  ref="menu_inpsection_date"
                                  close-on-content-click
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      ref="ref_inpsection_date"
                                      v-model="form.inpsection_date"
                                      :placeholder="
                                        props.item.properties.date_inspect &&
                                          props.item.properties.date_inspect.split(
                                            'T'
                                          )[0]
                                      "
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                      :disabled="disable_edit"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="form.inpsection_date"
                                    no-title
                                    scrollable
                                  >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="menu_inpsection_date = false"
                                    >
                                      Cancel
                                    </v-btn>
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="
                                        $refs.menu_inpsection_date.save(date)
                                      "
                                    >
                                      OK
                                    </v-btn>
                                  </v-date-picker>
                                </v-menu>
                              </td>
                              <td colspan="4" />
                            </tr>
                            <tr>
                              <td>Sling:</td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex shrink>
                                    <v-text-field
                                      class="v-text-field-single"
                                      ref="ref_num_chain"
                                      v-model="props.item.properties.num_chain"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex shrink>
                                    <v-select
                                      class="cond_dropdown"
                                      ref="ref_cond_chain"
                                      :items="opt_checkbox"
                                      v-model="props.item.properties.cond_chain"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <p class="ml-4 mt-3">
                                      Chain
                                    </p>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex shrink>
                                    <v-text-field
                                      class="v-text-field-single"
                                      ref="ref_num_cable"
                                      v-model="props.item.properties.num_cable"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown"
                                      ref="ref_cond_cable"
                                      :items="opt_checkbox"
                                      v-model="props.item.properties.cond_cable"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <p class="ml-2 mt-3">
                                      Cable
                                    </p>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex shrink>
                                    <v-text-field
                                      class="v-text-field-single"
                                      ref="ref_num_mlink"
                                      v-model="props.item.properties.num_mlink"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown"
                                      ref="ref_cond_mlink"
                                      :items="opt_checkbox"
                                      v-model="props.item.properties.cond_mlink"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <p class="ml-4 mt-3">
                                      Master Link
                                    </p>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex shrink>
                                    <v-text-field
                                      class="v-text-field-single"
                                      ref="ref_num_shackle"
                                      v-model="
                                        props.item.properties.num_shackle
                                      "
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown"
                                      ref="ref_cond_shackle"
                                      :items="opt_checkbox"
                                      v-model="
                                        props.item.properties.cond_shackle
                                      "
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <p class="mt-3">
                                      Shackle
                                    </p>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex shrink>
                                    <v-text-field
                                      class="v-text-field-single"
                                      ref="ref_num_hose"
                                      v-model="props.item.properties.num_hose"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown"
                                      ref="ref_cond_hose"
                                      :items="opt_checkbox"
                                      v-model="props.item.properties.cond_hose"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex justify-left>
                                    <p class="ml-4 mt-3">
                                      Hose
                                    </p>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td />
                            </tr>
                            <tr>
                              <td>Pin:</td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex shrink>
                                    <v-text-field
                                      class="v-text-field-single"
                                      ref="ref_num_8"
                                      v-model="props.item.properties.num_8"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown"
                                      ref="ref_cond_8"
                                      :items="opt_checkbox"
                                      v-model="props.item.properties.cond_8"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex justify-left>
                                    <p class="ml-0 mt-3">
                                      #8
                                    </p>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex shrink>
                                    <v-text-field
                                      class="v-text-field-single"
                                      ref="ref_num_9"
                                      v-model="props.item.properties.num_9"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown"
                                      ref="ref_cond_9"
                                      :items="opt_checkbox"
                                      v-model="props.item.properties.cond_9"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex justify-left>
                                    <p class="ml-0 mt-3">
                                      #9
                                    </p>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex shrink>
                                    <v-text-field
                                      class="v-text-field-single"
                                      ref="ref_num_10"
                                      v-model="props.item.properties.num_10"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown"
                                      ref="ref_cond_10"
                                      :items="opt_checkbox"
                                      v-model="props.item.properties.cond_10"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex justify-left>
                                    <p class="ml-0 mt-3">
                                      #10
                                    </p>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex shrink>
                                    <v-text-field
                                      class="v-text-field-single"
                                      ref="ref_num_nut"
                                      v-model="props.item.properties.num_nut"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown"
                                      ref="ref_cond_nut"
                                      :items="opt_checkbox"
                                      v-model="props.item.properties.cond_nut"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <span class="mt-3">
                                      Nut
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown cond_dropdown_solo"
                                      ref="ref_cond_tower"
                                      :items="opt_checkbox"
                                      v-model="props.item.properties.cond_tower"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <span class="ml-3">
                                      Tower
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown cond_dropdown_solo"
                                      ref="ref_cond_tree"
                                      :items="opt_checkbox"
                                      v-model="props.item.properties.cond_tree"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <span class="ml-3">
                                      Tree
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </td>
                            </tr>
                            <tr>
                              <td>Plate:</td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex shrink>
                                    <v-text-field
                                      class="v-text-field-single"
                                      ref="ref_num_plate1"
                                      v-model="props.item.properties.num_plate1"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown"
                                      ref="ref_cond_plate1"
                                      :items="opt_checkbox"
                                      v-model="
                                        props.item.properties.cond_plate1
                                      "
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex justify-left>
                                    <p class="ml-0 mt-3">
                                      1
                                    </p>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex shrink>
                                    <v-text-field
                                      class="v-text-field-single"
                                      ref="ref_num_plate075"
                                      v-model="
                                        props.item.properties.num_plate075
                                      "
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown"
                                      ref="ref_cond_plate075"
                                      :items="opt_checkbox"
                                      v-model="
                                        props.item.properties.cond_plate075
                                      "
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex justify-left>
                                    <p class="ml-0 mt-3">
                                      0.75
                                    </p>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex shrink>
                                    <v-text-field
                                      class="v-text-field-single"
                                      ref="ref_num_plate05"
                                      v-model="
                                        props.item.properties.num_plate05
                                      "
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown"
                                      ref="ref_cond_plate05"
                                      :items="opt_checkbox"
                                      v-model="
                                        props.item.properties.cond_plate05
                                      "
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex justify-left>
                                    <p class="ml-0 mt-3">
                                      0.5
                                    </p>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td colspan="3" />
                            </tr>
                            <tr>
                              <td>Grout:</td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown cond_dropdown_solo"
                                      ref="ref_cond_rocklite"
                                      :items="opt_checkbox"
                                      v-model="
                                        props.item.properties.cond_rocklite
                                      "
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <p class="pl-4 mt-3">
                                      Rocklite
                                    </p>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown cond_dropdown_solo"
                                      ref="ref_cond_epoxy"
                                      :items="opt_checkbox"
                                      v-model="props.item.properties.cond_epoxy"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex justify-left>
                                    <span class="ml-3">
                                      Epoxy
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown cond_dropdown_solo"
                                      ref="ref_cond_masonry"
                                      :items="opt_checkbox"
                                      v-model="
                                        props.item.properties.cond_masonry
                                      "
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex justify-left>
                                    <span class="ml-4">
                                      Masonry
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td colspan="3" />
                            </tr>
                            <tr>
                              <td>Base:</td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown cond_dropdown_solo"
                                      ref="ref_cond_rock"
                                      :items="opt_checkbox"
                                      v-model="props.item.properties.cond_rock"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex justify-left>
                                    <span class="ml-1">
                                      Rock
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown cond_dropdown_solo"
                                      ref="ref_cond_lockblock"
                                      :items="opt_checkbox"
                                      v-model="
                                        props.item.properties.cond_lockblock
                                      "
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex justify-left>
                                    <p class="ml-4 mt-3">
                                      Lock Block
                                    </p>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown cond_dropdown_solo"
                                      ref="ref_cond_treebase"
                                      :items="opt_checkbox"
                                      v-model="
                                        props.item.properties.cond_treebase
                                      "
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex justify-left>
                                    <span class="ml-1">
                                      Tree
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown cond_dropdown_solo"
                                      ref="ref_cond_unserviceable"
                                      :items="opt_checkbox"
                                      v-model="
                                        props.item.properties.cond_unserviceable
                                      "
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex justify-left>
                                    <span class="ml-4">
                                      Unserviceable
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td colspan="2" />
                            </tr>
                            <tr>
                              <td>Hanger:</td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex shrink>
                                    <v-text-field
                                      class="v-text-field-single"
                                      ref="ref_num_bar"
                                      v-model="props.item.properties.num_bar"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown"
                                      ref="ref_cond_bar"
                                      :items="opt_checkbox"
                                      v-model="props.item.properties.cond_bar"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex justify-left>
                                    <p class="ml-0 mt-3">
                                      Bar
                                    </p>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex shrink>
                                    <v-text-field
                                      class="v-text-field-single"
                                      ref="ref_num_hangernut"
                                      v-model="
                                        props.item.properties.num_hangernut
                                      "
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown"
                                      ref="ref_cond_hangernut"
                                      :items="opt_checkbox"
                                      v-model="
                                        props.item.properties.cond_hangernut
                                      "
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex justify-left>
                                    <p class="ml-4 mt-3">
                                      Hanger Nut
                                    </p>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown cond_dropdown_solo"
                                      ref="ref_cond_hangerrock"
                                      :items="opt_checkbox"
                                      v-model="
                                        props.item.properties.cond_hangerrock
                                      "
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex justify-left>
                                    <span class="ml-2">
                                      Rock
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex shrink>
                                    <v-text-field
                                      class="v-text-field-single"
                                      ref="ref_num_rope"
                                      v-model="props.item.properties.num_rope"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown"
                                      ref="ref_cond_rope"
                                      :items="opt_checkbox"
                                      v-model="props.item.properties.cond_rope"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <p class="ml-0 mt-3">
                                      Rope
                                    </p>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown"
                                      ref="ref_cond_hangertree"
                                      :items="opt_checkbox"
                                      v-model="
                                        props.item.properties.cond_hangertree
                                      "
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <p class="ml-0 mt-3">
                                      Tree
                                    </p>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td />
                            </tr>
                            <tr>
                              <td>Pad:</td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex shrink>
                                    <v-text-field
                                      class="v-text-field-single"
                                      ref="ref_num_trackbelt"
                                      v-model="
                                        props.item.properties.num_trackbelt
                                      "
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown"
                                      ref="ref_cond_trackbelt"
                                      :items="opt_checkbox"
                                      v-model="
                                        props.item.properties.cond_trackbelt
                                      "
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <p class="ml-4 mt-3">
                                      Track Belt
                                    </p>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex shrink>
                                    <v-text-field
                                      class="v-text-field-single"
                                      ref="ref_num_yellow"
                                      v-model="props.item.properties.num_yellow"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown"
                                      ref="ref_cond_yellow"
                                      :items="opt_checkbox"
                                      v-model="
                                        props.item.properties.cond_yellow
                                      "
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <p class="ml-3 mt-3">
                                      Yellow
                                    </p>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout row align-center>
                                  <v-flex shrink>
                                    <v-text-field
                                      class="v-text-field-single"
                                      ref="ref_num_ABS"
                                      v-model="props.item.properties.num_ABS"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <v-select
                                      class="cond_dropdown"
                                      ref="ref_cond_ABS"
                                      :items="opt_checkbox"
                                      v-model="props.item.properties.cond_ABS"
                                      :disabled="disable_edit"
                                    />
                                  </v-flex>
                                  <v-flex>
                                    <p class="ml-0 mt-3">
                                      ABS
                                    </p>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td colspan="3" />
                            </tr>
                            <tr>
                              <td>Work Required?:</td>
                              <td colspan="2">
                                <v-select
                                  ref="ref_work_required"
                                  :items="opt_yes_no"
                                  v-model="props.item.properties.work_required"
                                  :disabled="disable_edit"
                                />
                              </td>
                              <td colspan="4" />
                            </tr>
                            <tr>
                              <td>Work Completed:</td>
                              <td colspan="2">
                                <v-menu
                                  ref="menu_completed_date"
                                  close-on-content-click
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      ref="ref_completed_date"
                                      v-model="form.completed_date"
                                      :placeholder="
                                        props.item.properties.work_complete &&
                                          props.item.properties.work_complete.split(
                                            'T'
                                          )[0]
                                      "
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                      :disabled="disable_edit"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="form.completed_date"
                                    no-title
                                    scrollable
                                  >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="menu_completed_date = false"
                                    >
                                      Cancel
                                    </v-btn>
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="
                                        $refs.menu_completed_date.save(date)
                                      "
                                    >
                                      OK
                                    </v-btn>
                                  </v-date-picker>
                                </v-menu>
                              </td>
                              <td colspan="2">
                                <v-layout row>
                                  <v-flex>
                                    <v-text-field
                                      ref="ref_completed_by"
                                      v-model="
                                        props.item.properties.completed_by
                                      "
                                      :disabled="disable_edit"
                                      label="Completed by"
                                    />
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td colspan="2" />
                            </tr>
                            <tr>
                              <td>Overall Anchor Condition:</td>
                              <td colspan="2">
                                <v-select
                                  ref="ref_overall_anch_cond"
                                  :items="opt_overall_anch_cond"
                                  v-model="
                                    props.item.properties.overall_anch_cond
                                  "
                                  :disabled="disable_edit"
                                ></v-select>
                              </td>
                              <td colspan="4" />
                            </tr>
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </template>
              </td>
            </tr>

            <tr>
              <td>Notes</td>
              <td>
                <v-textarea
                  ref="ref_notes"
                  v-model="props.item.properties.notes"
                  :disabled="disable_edit"
                />
              </td>
            </tr>
          </template>
          <template slot="footer">
            <tr>
              <td colspan="100%">
                <v-spacer class="hidden-sm-and-down"></v-spacer>
                <v-btn
                  v-if="base64image"
                  @click.stop="
                    methodEditImageGroomingWinchGeoJson({
                      mountain: $refs.ref_mountain.value,
                      zone: $refs.ref_zone.value,
                      trail_name: $refs.ref_trail_name.value,
                      a_number: $refs.ref_a_number.value,
                      loc_descript: $refs.ref_loc_descript.value,
                      date_inspect: $refs.ref_inpsection_date.value,
                      num_chain: $refs.ref_num_chain.value,
                      cond_chain: $refs.ref_cond_chain.value,
                      num_cable: $refs.ref_num_cable.value,
                      cond_cable: $refs.ref_cond_cable.value,
                      num_mlink: $refs.ref_num_mlink.value,
                      cond_mlink: $refs.ref_cond_mlink.value,
                      num_shackle: $refs.ref_num_shackle.value,
                      cond_shackle: $refs.ref_cond_shackle.value,
                      num_hose: $refs.ref_num_hose.value,
                      cond_hose: $refs.ref_cond_hose.value,
                      num_8: $refs.ref_num_8.value,
                      cond_8: $refs.ref_cond_8.value,
                      num_9: $refs.ref_num_9.value,
                      cond_9: $refs.ref_cond_9.value,
                      num_10: $refs.ref_num_10.value,
                      cond_10: $refs.ref_cond_10.value,
                      num_nut: $refs.ref_num_nut.value,
                      cond_nut: $refs.ref_cond_nut.value,
                      cond_tower: $refs.ref_cond_tower.value,
                      cond_tree: $refs.ref_cond_tree.value,
                      num_plate1: $refs.ref_num_plate1.value,
                      cond_plate1: $refs.ref_cond_plate1.value,
                      num_plate075: $refs.ref_num_plate075.value,
                      cond_plate075: $refs.ref_cond_plate075.value,
                      num_plate05: $refs.ref_num_plate05.value,
                      cond_plate05: $refs.ref_cond_plate05.value,
                      cond_rocklite: $refs.ref_cond_rocklite.value,
                      cond_epoxy: $refs.ref_cond_epoxy.value,
                      cond_masonry: $refs.ref_cond_masonry.value,
                      cond_rock: $refs.ref_cond_rock.value,
                      cond_lockblock: $refs.ref_cond_lockblock.value,
                      cond_treebase: $refs.ref_cond_treebase.value,
                      cond_unserviceable: $refs.ref_cond_unserviceable.value,
                      cond_bar: $refs.ref_cond_bar.value,
                      num_bar: $refs.ref_num_bar.value,
                      cond_hangernut: $refs.ref_cond_hangernut.value,
                      num_hangernut: $refs.ref_num_hangernut.value,
                      cond_hangerrock: $refs.ref_cond_hangerrock.value,
                      num_rope: $refs.ref_num_rope.value,
                      cond_rope: $refs.ref_cond_rope.value,
                      cond_hangertree: $refs.ref_cond_hangertree.value,
                      num_trackbelt: $refs.ref_num_trackbelt.value,
                      cond_trackbelt: $refs.ref_cond_trackbelt.value,
                      num_yellow: $refs.ref_num_yellow.value,
                      cond_yellow: $refs.ref_cond_yellow.value,
                      num_ABS: $refs.ref_num_ABS.value,
                      cond_ABS: $refs.ref_cond_ABS.value,
                      work_required: $refs.ref_work_required.value,
                      work_complete: $refs.ref_completed_date.value,
                      completed_by: $refs.ref_completed_by.value,
                      overall_anch_cond: $refs.ref_overall_anch_cond.value,
                      notes: $refs.ref_notes.value
                    });
                    disable_edit = true;
                    form.inspection_date = null;
                    form.completed_date = null;
                    methodToggleSingleLayer('grooming', 'winch', false);
                  "
                  :disabled="disable_edit"
                  color="success"
                  >Save</v-btn
                >
                <v-btn
                  v-else
                  @click.stop="
                    methodEditGroomingWinchGeoJson({
                      mountain: $refs.ref_mountain.value,
                      zone: $refs.ref_zone.value,
                      trail_name: $refs.ref_trail_name.value,
                      a_number: $refs.ref_a_number.value,
                      loc_descript: $refs.ref_loc_descript.value,
                      date_inspect: $refs.ref_inpsection_date.value,
                      num_chain: $refs.ref_num_chain.value,
                      cond_chain: $refs.ref_cond_chain.value,
                      num_cable: $refs.ref_num_cable.value,
                      cond_cable: $refs.ref_cond_cable.value,
                      num_mlink: $refs.ref_num_mlink.value,
                      cond_mlink: $refs.ref_cond_mlink.value,
                      num_shackle: $refs.ref_num_shackle.value,
                      cond_shackle: $refs.ref_cond_shackle.value,
                      num_hose: $refs.ref_num_hose.value,
                      cond_hose: $refs.ref_cond_hose.value,
                      num_8: $refs.ref_num_8.value,
                      cond_8: $refs.ref_cond_8.value,
                      num_9: $refs.ref_num_9.value,
                      cond_9: $refs.ref_cond_9.value,
                      num_10: $refs.ref_num_10.value,
                      cond_10: $refs.ref_cond_10.value,
                      num_nut: $refs.ref_num_nut.value,
                      cond_nut: $refs.ref_cond_nut.value,
                      cond_tower: $refs.ref_cond_tower.value,
                      cond_tree: $refs.ref_cond_tree.value,
                      num_plate1: $refs.ref_num_plate1.value,
                      cond_plate1: $refs.ref_cond_plate1.value,
                      num_plate075: $refs.ref_num_plate075.value,
                      cond_plate075: $refs.ref_cond_plate075.value,
                      num_plate05: $refs.ref_num_plate05.value,
                      cond_plate05: $refs.ref_cond_plate05.value,
                      cond_rocklite: $refs.ref_cond_rocklite.value,
                      cond_epoxy: $refs.ref_cond_epoxy.value,
                      cond_masonry: $refs.ref_cond_masonry.value,
                      cond_rock: $refs.ref_cond_rock.value,
                      cond_lockblock: $refs.ref_cond_lockblock.value,
                      cond_treebase: $refs.ref_cond_treebase.value,
                      cond_unserviceable: $refs.ref_cond_unserviceable.value,
                      cond_bar: $refs.ref_cond_bar.value,
                      num_bar: $refs.ref_num_bar.value,
                      cond_hangernut: $refs.ref_cond_hangernut.value,
                      num_hangernut: $refs.ref_num_hangernut.value,
                      cond_hangerrock: $refs.ref_cond_hangerrock.value,
                      num_rope: $refs.ref_num_rope.value,
                      cond_rope: $refs.ref_cond_rope.value,
                      cond_hangertree: $refs.ref_cond_hangertree.value,
                      num_trackbelt: $refs.ref_num_trackbelt.value,
                      cond_trackbelt: $refs.ref_cond_trackbelt.value,
                      num_yellow: $refs.ref_num_yellow.value,
                      cond_yellow: $refs.ref_cond_yellow.value,
                      num_ABS: $refs.ref_num_ABS.value,
                      cond_ABS: $refs.ref_cond_ABS.value,
                      work_required: $refs.ref_work_required.value,
                      work_complete: $refs.ref_completed_date.value,
                      completed_by: $refs.ref_completed_by.value,
                      overall_anch_cond: $refs.ref_overall_anch_cond.value,
                      notes: $refs.ref_notes.value
                    });
                    disable_edit = true;
                    form.inspection_date = null;
                    form.completed_date = null;
                    methodToggleSingleLayer('grooming', 'winch', false);
                  "
                  :disabled="disable_edit"
                  color="success"
                  >Save</v-btn
                >
                <v-spacer class="hidden-sm-and-down"></v-spacer>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
    <!-- Delete confirmation dialog -->
    <v-dialog v-model="confirm_delete" max-width="500px">
      <v-card>
        <v-card-title>
          <span>Are you sure? This is permanent.</span>
        </v-card-title>
        <v-card-actions>
          <!-- confirm delete button -->
          <v-btn
            color="error"
            flat
            @click.stop="
              confirm_delete = false;
              disable_edit = true;
              methodDeleteGroomingWinchGeoJson();
              methodToggleSingleLayer('bikepark', 'signs', false);
            "
            >Delete</v-btn
          >
          <!-- Cancel button -->
          <v-btn color="primary" flat @click.stop="confirm_delete = false"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<style scoped>
table {
  padding-top: 20px;
}
.v-text-field-single {
  width: 30px;
}
.checkbox-padding {
  padding-top: 20px;
}
.cond_dropdown_solo {
  margin-left: 30px;
}
.cond_dropdown {
  width: 30px;
}
</style>
<script>
export default {
  data() {
    return {
      attemptAutoRotate: false,
      base64image: null,
      confirm_delete: false,
      menu_inspection_date: false,
      menu_completed_date: false,
      form: {
        inspection_date: null,
        completed_date: null
      },
      disable_edit: true,
      loading: true,
      persistent: false,
      hideheaders: true,
      hideactions: true,
      solo: true,
      checkbox_false_value: "false",
      checkbox_true_value: "true",
      opt_mountain: [{ text: "Whistler" }, { text: "Blackcomb" }],
      opt_overall_anch_cond: [
        { text: "Uninspected" },
        { text: "Good" },
        { text: "Fair" },
        { text: "Poor" }
      ],
      opt_yes_no: [{ text: "Yes" }, { text: "No" }],
      opt_checkbox: [
        { text: "", value: "" },
        { text: "✅", value: "Good" },
        { text: "❗", value: "Fair" },
        { text: "❌", value: "Poor" },
        { text: "❔", value: "Insp req" }
      ]
    };
  },
  computed: {
    computedImageUrl() {
      return (
        "https://api2.alchemymapping.com/images/" +
        this.$store.state.ui.image.filename.filename.filename
      );
    },
    computedLatLng() {
      if (this.$store.state.mapLayers.grooming.layers.winch.geojson.features) {
        const winch = this.$store.state.mapLayers.grooming.layers.winch.geojson
          .features;
        const result = winch.filter(
          item => item.properties.id == this.computedGroomingWinchId
        );
        return result;
      }
      return [];
    },
    computedZone() {
      const zones = this.$store.state.mapLayers.grooming.layers.winch.geojson
        .features;
      const zonesArr = [];
      zones.map(item => {
        zonesArr.push(item.properties.zone);
      });
      const uniqueZones = Array.from(new Set(zonesArr));
      let finalResults = [];
      uniqueZones.map(item => {
        finalResults.push({
          text: item
        });
      });
      return finalResults.sort((a, b) => (a.text < b.text ? -1 : 1));
    },
    computedTrailName() {
      const trailNames = this.$store.state.mapLayers.grooming.layers.winch
        .geojson.features;
      const trailNamesArr = [];
      trailNames.map(item => {
        trailNamesArr.push(item.properties.trail_name);
      });
      const uniqueTrailNames = Array.from(new Set(trailNamesArr));
      let finalResults = [];
      uniqueTrailNames.map(item => {
        finalResults.push({
          text: item
        });
      });
      return finalResults.sort((a, b) => (a.text < b.text ? -1 : 1));
    },
    computedA_Number() {
      if (this.computedGroomingWinchVisibility) {
        const winch = this.$store.state.mapLayers.grooming.layers.winch.geojson
          .features;
        // grabs the extent of the currently viewed ID
        let result = winch.filter(
          item => item.properties.id == this.computedGroomingWinchId
        );
        return result[0].properties.a_number;
      }
      return [];
    },
    computedGroomingWinchGeoJsonFeature() {
      if (this.$store.state.mapLayers.grooming.layers.winch.geojson.features) {
        const winch = this.$store.state.mapLayers.grooming.layers.winch.geojson
          .features;
        const result = winch.filter(
          item => item.properties.id == this.computedGroomingWinchId
        );
        return result;
      }
      return [];
    },
    computedGroomingWinchVisibility() {
      return this.$store.state.mapLayers.grooming.layers.winch.visibility
        .singleView;
    },
    computedGroomingWinchLoading() {
      return this.$store.state.mapLayers.grooming.layers.winch.loading;
    },
    computedGroomingWinchId() {
      return this.$store.state.mapLayers.grooming.layers.winch.visibility
        .singleId;
    },
    computedAuth() {
      return this.$store.state.auth;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    methodSetOutput(file) {
      this.base64image = file;
    },
    methodGetGroomingWinchImage() {
      this.$store.dispatch("actionGetImage", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/grooming/winch/image/" +
          this.computedGroomingWinchId,
        token: this.computedAuthToken
      });
    },
    methodDeleteGroomingWinchGeoJson() {
      this.$store
        .dispatch("actionDeleteGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/grooming/winch/" +
            this.computedGroomingWinchId,
          dept: "grooming",
          layer: "winch",
          token: this.computedAuthToken
        })
        .then(() => {
          this.methodToggleSingleLayer(
            "grooming",
            "winch",
            true,
            this.computedGroomingWinchId
          );
          setTimeout(() => {
            this.methodGetGroomingWinchGeoJson();
          }, 350);
        });
    },
    methodStringToBoolean(str) {
      if (str === "0") {
        return false;
      } else if (str === "1") {
        return true;
      } else {
        return null;
      }
    },
    methodCloseListLayer(dept, layer) {
      this.$store.commit("mutationCloseListLayer", {
        dept: dept,
        layer: layer
      });
    },
    // method to get geojson
    methodGetGroomingWinchGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url: "https://api2.alchemymapping.com/vail/whistler/grooming/winch",
        dept: "grooming",
        layer: "winch",
        token: this.computedAuthToken
      });
    },
    methodEditImageGroomingWinchGeoJson(data) {
      this.$store
        .dispatch("actionEditJsonImage", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/grooming/winch/" +
            this.computedGroomingWinchId,
          imageUrl:
            "https://api2.alchemymapping.com/vail/whistler/grooming/winch/image",
          base64data: this.base64image,
          dept: "grooming",
          layer: "winch",
          token: this.computedAuthToken,
          payload: data,
          belongstoid: this.computedGroomingWinchId
        })
        .then(() => {
          this.base64image = null;
        });
    },
    methodEditGroomingWinchGeoJson(data) {
      this.$store
        .dispatch("actionEditGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/grooming/winch/" +
            this.computedGroomingWinchId,
          dept: "grooming",
          layer: "winch",
          token: this.computedAuthToken,
          payload: data
        })
        .then(
          setTimeout(() => {
            this.methodGetGroomingWinchGeoJson();
          }, 250)
        );
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.grooming.layers.winch.visibility.singleView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetGroomingWinchGeoJson();
        this.methodGetGroomingWinchImage();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.grooming.layers.winch.geojson": function(newValue) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
